module.exports = __webpack_public_path__ + "static/media/Forestry-Yellow-BG-2nd-Layer-Two@2x.2c914c40.png";